module.exports = __webpack_public_path__ + "e909fedaff6b80c1aac0780eb4b87b71.svg";


//////////////////
// WEBPACK FOOTER
// ./shared/favicons/safari-pinned-tab.svg
// module id = 1154
// module chunks = 2